import { useEffect, useRef } from 'react'

// Controlled-dropdown helper: calls onClose on any mousedown outside the
// returned ref's element. Listens only while `active` is true.
export function useOutsideClick(onClose, active = true) {
  const ref = useRef(null)
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    if (!active) return
    function onDown(e) {
      if (ref.current && !ref.current.contains(e.target)) onCloseRef.current()
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [active])

  return ref
}
